@if (isOpen()) {
  <div class="fixed inset-0 z-10 bg-gray-900/50 animate-fade-in" (click)="onBackdropClick()"></div>
}

<div class="fixed bottom-0 left-0 right-0 z-20">
  <div [class]="'bg-white shadow-2xl flex flex-col ' + (isOpen() ? 'rounded-t-2xl' : '')">
    <div (click)="toggleDrawer()"
         class="p-2 flex items-center justify-between cursor-pointer flex-shrink-0 bg-brand text-white"
         [class.border-b]="isOpen()"
         [class.border-gray-200]="isOpen()">
      <ng-content select="[header]" />
      <app-icons [icon]="isOpen() ? 'chevron-down' : 'chevron-up'" svgClass=""/>
    </div>

    <div [class]="'overflow-y-auto transition-all duration-300 ' + (isOpen() ? maxHeight() : 'max-h-0')">
      <ng-content />
    </div>
  </div>
</div>
<div class="fixed bottom-0 left-0 right-0 h-2 bg-brand z-20"></div>
